import React from "react";
import useCategorizeFiles from "../../hooks/useCategorizeFiles";
import { useSelector } from "react-redux";
import { Typography, Box, Stack } from "@mui/material";
import SubmittedFilesPreview from "./SubmittedFilesPreview";

const ManifestFilesPreview = ({
	contentSource,
	content,
	isEditing,
	localContentSource,
}) => {
	const oneDriveFiles = useSelector((state) => state.oneDriveContent.files);
	const manifestPreview = useSelector((state) => state.manifestPreview);
	const contentForm = useSelector((state) => state.contentForm);

	const { videos, images, audios, csv, pdfs, loading, clearFiles } =
		useCategorizeFiles(
			manifestPreview?.contentSource === "onedrive"
				? oneDriveFiles
				: null,
			manifestPreview?.contentSource
		);

	const renderFilePreview = (file, fileType) => (
		<Box key={file.name || file.id}>
			<Typography textTransform="capitalize" variant="body1">
				{fileType} File:
			</Typography>
			<Typography
				textTransform="capitalize"
				component="span"
				variant="body2"
				fontSize="12px"
				color="primary.light"
			>
				({file.name})
			</Typography>
			{fileType === "image" &&
			manifestPreview.contentSource == "onedrive" ? (
				<embed
					src={file.getUrl || URL.createObjectURL(file)}
					alt={file.name}
					style={{ maxWidth: "100%", height: "auto" }}
				/>
			) : fileType === "image" &&
			  manifestPreview.contentSource === "local" ? (
				<img
					src={file.getUrl || URL.createObjectURL(file)}
					alt={file.name}
					style={{ maxWidth: "100%", height: "auto" }}
				/>
			) : (
				<embed
					type={
						fileType === "video" ? "video/webm" : "application/pdf"
					}
					src={file.getUrl || URL.createObjectURL(file)}
					width="100%"
				/>
			)}
		</Box>
	);

	const renderLocalFiles = () => {
		const { masterFileContent, trailerContent, posters } =
			localContentSource;
		return (
			<>
				{masterFileContent.file &&
					renderFilePreview(masterFileContent.file, "Master ")}
				{trailerContent.file &&
					renderFilePreview(trailerContent.file, "Trailer")}
				{posters.map((poster, index) =>
					renderFilePreview(poster, "image")
				)}
			</>
		);
	};

	if (manifestPreview.contentSource === "s3") {
		return <SubmittedFilesPreview content={contentForm} />;
	}

	if (manifestPreview.contentSource === "onedrive")
		return (
			<Stack gap={3}>
				<>
					{images.map((image) => renderFilePreview(image, "image"))}
					{videos.map((video) => renderFilePreview(video, "video"))}
					{pdfs.map((pdf) => renderFilePreview(pdf, "pdf"))}
				</>
			</Stack>
		);

	return <Stack gap={3}>{renderLocalFiles()}</Stack>;
};

export default ManifestFilesPreview;
